export default "/profile/images/logo.png?7d2fb038650cdeaf97cc87ccf858e9b3";